module.exports = __webpack_public_path__ + "static/img/service-01.0e31b88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/service-01.jpg
// module id = /LpT
// module chunks = 13